let lastEventTime = 0
//let lastScrollId = ""
export function deduplicateEvent(
  e:       | React.MouseEvent
      | React.TouchEvent
      | React.BaseSyntheticEvent
      | React.SyntheticEvent
      | Event,
  thresholdMs = 250
): boolean {
  const now = Date.now()
  const isDuplicate = now - lastEventTime < thresholdMs
  console.log(e)
  console.log('isDuplicate', now, lastEventTime, now - lastEventTime,  isDuplicate)
  if (!isDuplicate) {
    lastEventTime = now
  }

  return !isDuplicate
}
